import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          // Ensure proper focus management
          '& .MuiDialog-paper': {
            // Prevent aria-hidden from being applied to dialog content
            'aria-hidden': 'false',
          },
        },
      },
      defaultProps: {
        // Ensure proper focus management by default
        keepMounted: false,
        disableRestoreFocus: false,
        disableEnforceFocus: false,
        disableAutoFocus: false,
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          // Ensure proper focus management for modals
          '& .MuiModal-backdrop': {
            // Prevent aria-hidden from being applied to backdrop
            'aria-hidden': 'false',
          },
        },
      },
    },
    MuiMenu: {
      defaultProps: {
        // Prevent focus management issues with Menu components
        disableRestoreFocus: false,
        disableEnforceFocus: false,
        disableAutoFocus: false,
        keepMounted: false,
      },
      styleOverrides: {
        root: {
          // Ensure Menu doesn't interfere with focus management
          '&[aria-hidden="true"]': {
            // Override aria-hidden when Menu contains focused elements
            '&:focus-within': {
              'aria-hidden': 'false !important',
            },
          },
        },
      },
    },
    MuiPopover: {
      defaultProps: {
        // Prevent focus management issues with Popover components  
        disableRestoreFocus: false,
        disableEnforceFocus: false,
        disableAutoFocus: false,
        keepMounted: false,
      },
      styleOverrides: {
        root: {
          // Ensure Popover doesn't interfere with focus management
          '&[aria-hidden="true"]': {
            // Override aria-hidden when Popover contains focused elements
            '&:focus-within': {
              'aria-hidden': 'false !important',
            },
          },
        },
      },
    },
  },
  // Add custom CSS properties for accessibility
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

export default theme; 